import GrapesJSEditor from "@papier/grapesjs-editor";
import { createFileRoute } from "@tanstack/react-router";
import { ParentSize } from "@visx/responsive";

export const Route = createFileRoute("/grapes-preview")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex h-screen w-screen">
      <ParentSize>
        {({ height }) => (
          <GrapesJSEditor
            initialContent={{ components: "", style: "" }}
            height={height}
            initialSchema={{ id: "default", name: "Default Schema", schema: [] }}
            onSchemaChange={() => {}}
            onUpdate={() => {}}
            mode="preview"
          />
        )}
      </ParentSize>
    </div>
  );
}
